import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMDataGrid } from '../../ui-elements/MyMDataGrid';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { constants } from '../../constants';
import { SurveyRegistration } from '../MyM804_SurveyRegistration/SurveyRegistration';


export const SurveyListResult = React.memo((props) => {
  const { screenId, surveyList, setNeedsRefreshPage, needRefreshPage, isLoading } = props;
  const { controlSettings, messageList } = useWebContext(screenId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [surveyId, setSurveyId] = useState('');
  
  /**ModalClose */
  const handleModalClose = () => {
    setIsModalOpen(false);
  }
  /** SurveyRegistrationでのSurvey更新コールバック処理 */
  const callbackUpdateSurvey = () => setNeedsRefreshPage(true); 
  const columns = [
    {
      field: 'No',
      headerName: controlSettings.LabelList.lblNoHeader,
      minwidth: 100,
      flex: 2,
      sortable: false,
      renderCell: (params) => <MyMLink onClick={() => openModal_SurveyRegistration(params.row.id)} align='center' >{params.row.No}</MyMLink>
    },
    {
      field: 'Term',
      headerName: controlSettings.LabelList.lblTermHeader,
      minwidth: 100,
      flex: 2,
      sortable: false,
    },
    {
      field: 'Status',
      headerName: controlSettings.LabelList.lblStatusHeader,
      minwidth: 100,
      flex: 2,
      sortable: false,
    },
    {
      field: 'Result',
      headerName: controlSettings.LabelList.lblResultHeader,
      minwidth: 100,
      flex: 2,
      sortable: false,
      renderCell: (params) => <NavigateLink to={`/MyM802/${params.row.id}`} newTabNavigate={true}>{params.row.Result}</NavigateLink>
    },
  ];

  columns.forEach(x => x.cellClassName = 'align-items-center d-flex');

  const dataList = surveyList.map((row) => {
    const currentDate = new Date();

    if (row.Status === constants.SurveyStatus.Scheduled) {
      const termFromDate = new Date(row.TermFrom);
      const termToDate = new Date(row.TermTo);

      if (termFromDate >= currentDate) {
        row.Status = controlSettings.LabelList.lblScheduled;
      }
      if (termFromDate <= currentDate && termToDate > currentDate) {
        row.Status = controlSettings.LabelList.lblActive;
        row.Result = controlSettings.LabelList.lblResultValue;
      }
      if (termToDate < currentDate) {
        row.Status = controlSettings.LabelList.lblClosed;
        row.Result = controlSettings.LabelList.lblResultValue;
      }
    }
    if (row.Status === constants.SurveyStatus.Draft) {
      row.Status = controlSettings.LabelList.lblDraft;
    }
    return {
      id: row.Surveyid,
      No: row.Surveyid,
      Term: row.Term,
      Status: row.Status,
      Result: row.Result,
    };
  });

  const openModal_SurveyRegistration = (props) => {
    setIsModalOpen(true);
    setSurveyId(props);
  }

  return ( 
    <Box sx={{ width: '100%', padding: '25px 40px 0px 40px' }}>
      <Box>
        <MyMLabel fontWeight='bold' fontSize='25px'>{controlSettings.LabelList.lblTitle}</MyMLabel>
      </Box>
      <Box sx={{ backgroundColor: '#F5F5F5' }}>
        <MyMDataGrid
          rowHeight={dataList.length === 0 ? 1 : 60}
          columnHeaderHeight={40}
          columns={columns}
          dataList={dataList}
          needRefreshPage={needRefreshPage}
          disableColumnResize={true}
          uniqueyKey={(row) => row.id}
          localeText={{ noRowsLabel: "" }}
          loading={isLoading}
          autoHeight
        />
      </Box>
      {!isLoading && dataList.length === 0
        ? <MyMLabel className='d-flex justify-content-center' fontSize='20px' sx={{ paddingTop: '20px', paddingBottom: '20px' }}>{messageList.MyM_MSG_I_0059}</MyMLabel> : null}
        {/*AddNew/Closeボタン*/}
        <Grid container alignItems="center" spacing={3} sx={{ padding: '30px 40px 30px 0px', justifyContent: "flex-end" }}>
          <Grid item>
            <MyMButton onClick={() => { openModal_SurveyRegistration(0) }} >{controlSettings.LabelList.btnAddNew}</MyMButton>
          </Grid>
          <Grid item>
            <MyMCloseButton closeText={controlSettings.LabelList.btnClose} />
          </Grid>
        </Grid>
        <MyMModal
          open={isModalOpen}
          onClose={handleModalClose}
          width='80%'
          height='95%'
        >
          <SurveyRegistration
            surveyId={surveyId}
            handleModalClose={handleModalClose}
            callbackUpdateSurvey={callbackUpdateSurvey}
          />
        </MyMModal>
      </Box>
  )
}
)
